export default __webpack_public_path__ + "static/iconography-image-d-bc016bd1eb8104bff5f56a35e0b12705.png";